module.exports = __webpack_public_path__ + "static/media/huawei+.0808d5e7.svg";